export const OTPTypes = {
	Other: 0,
	Authentication: 1,
	Transaction: 2,
	PasswordReset: 3,
};
